import { render, staticRenderFns } from "./AddClassLevelModal.vue?vue&type=template&id=cb1e370e&scoped=true&"
import script from "./AddClassLevelModal.vue?vue&type=script&lang=js&"
export * from "./AddClassLevelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1e370e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb1e370e')) {
      api.createRecord('cb1e370e', component.options)
    } else {
      api.reload('cb1e370e', component.options)
    }
    module.hot.accept("./AddClassLevelModal.vue?vue&type=template&id=cb1e370e&scoped=true&", function () {
      api.rerender('cb1e370e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/classes/AddClassLevelModal.vue"
export default component.exports